import axios from '@/libs/api.request'

/**
 * 批量更新所在动态分类
 */
export const updateCate = (cate_id, ids) => {
    const data = {
        "cate_id": cate_id,
        "ids": ids,
    }
    return axios.request({
        url: '/api/admin/moment/updateCate',
        data,
        method: 'post'
    })
}

/**
 * 批量更新所在话题
 */
export const updateTopic = (topic_id, ids) => {
    const data = {
        "topic_id": topic_id,
        "ids": ids,
    }
    return axios.request({
        url: '/api/admin/moment/updateTopic',
        data,
        method: 'post'
    })
}

/**
 * 导出动态
 */
export const exportMoment = (nickName, mail, moment_type, cate_id, topic_id, sh_state, start_date, end_date) => {
    const data = {
        "nickName": nickName,
        "mail": mail,
        "moment_type": moment_type,
        "cate_id": cate_id,
        "topic_id": topic_id,
        "sh_state": sh_state,
        "start_date": start_date,
        "end_date": end_date
    }
    return axios.request({
        url: '/api/admin/moment/export',
        data,
        method: 'post'
    })
}